import { render, staticRenderFns } from "./ModalExibirNaTarjaFullScreen.vue?vue&type=template&id=79343690"
import script from "./ModalExibirNaTarjaFullScreen.vue?vue&type=script&lang=js"
export * from "./ModalExibirNaTarjaFullScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports